namespace $.$$ {
	export class $shm_hitalama_map_widget_float_code_bench extends $.$shm_hitalama_map_widget_float_code_bench {

		runtime_runner() {
			return this.map().runtime().widget_runner( this.widget().link_str() )
		}

		process_host() {
			return this.runtime_runner()
		}

		run_click() {
			this.run()
		}

		run() {
			return this.run_auto()
		}

		run_if_enabled() {
			return this.runtime_runner().run_if_enabled()
		}

		run_auto( next?: null ) {
			return this.runtime_runner().run_auto( next )
		}

		result_visible() {
			if( !this.Process().last() ) return []
			return super.result_visible()
		}

		process_state() {
			const data = this.Process().last()?.data()
			if( data?.status !== 'failed' ) return super.process_state()

			const error = data.error
			this.map().runtime().runtime_sourcemap().error_stack_remap( error )
			return {
				_format: 'error',
				message: this.$.$mol_error_message( error ),
				stack: this.error_stack_text( error ),
			}
		}

		error_stack_text( error: unknown ) {
			if( !( error instanceof Error ) ) return String( error )

			const remapped = ( error as { $shm_hitalama_map_runtime_stack?: unknown } ).$shm_hitalama_map_runtime_stack
			if( typeof remapped === 'string' ) return remapped

			const stack = ( error as { stack?: unknown } ).stack
			if( typeof stack === 'string' ) return stack
			if( Array.isArray( stack ) ) return stack.map( ( frame: unknown ) => this.error_frame_text( frame ) ).join( '\n' )

			return this.$.$mol_error_message( error )
		}

		error_frame_text( frame: any ) {
			const title = frame?.function || frame?.method || '<anonymous>'
			const source = frame?.source || frame?.eval || ''
			const pos = Array.isArray( frame?.pos )
				? `:${ Number( frame.pos[0] ) + 1 }:${ Number( frame.pos[1] ) + 1 }`
				: ''

			return source ? `${ title } @ ${ source }${ pos }` : title
		}

		time_passed(): string {
			const process = this.Process().last()
			if( !process ) return ''
			return super.time_passed()
				.replace( '{start}', this.started_at() )
				.replace( '{passed}', this.duration() )
		}

		create_view_widget() {
			const exists = this.widget().view_widget()
			const view = this.widget().code_view_widget_open()
			if( !view ) return
			if( !exists ) this.widget().enabled( true )
			this.Map_page().go_to_widget( view.link() )
			this.Map_page().selected_links( [ view.link() ] )
		}

		running_fiber_visible(): readonly ( any )[] {
			return this.$.$mol_state_local.value< boolean >( 'running_fiber_visible' )
				? this.Process().running_fiber_visible() : []
		}
		
	}
}
